import React from 'react';

import {MainLayout} from 'widgets/layout';
import {listPageClassName} from 'shared/ui/ListPage/ListPage';
import {AdminPaymentsScreen} from 'features/admin';

const AdminPaymentsPage: React.FC = () => (
    <MainLayout className={listPageClassName}>
        <AdminPaymentsScreen />
    </MainLayout>
);

export default AdminPaymentsPage;
